(function () {
  var DURATION = 300;
  var COLLAPSED_HEIGHT = 150;
  var PANEL_MARGIN = 10;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function onHeightTransitionEnd(element, callback) {
    var done = false;
    var timeoutId;
    var onTransitionEnd = function (event) {
      if (event.target !== element || event.propertyName !== 'height') return;
      finish();
    };
    var finish = function () {
      if (done) return;
      done = true;
      element.removeEventListener('transitionend', onTransitionEnd);
      window.clearTimeout(timeoutId);
      callback();
    };

    element.addEventListener('transitionend', onTransitionEnd);
    timeoutId = window.setTimeout(finish, DURATION + 50);

    return function cancel() {
      if (done) return;
      done = true;
      element.removeEventListener('transitionend', onTransitionEnd);
      window.clearTimeout(timeoutId);
    };
  }

  function afterTransition(element, callback) {
    onHeightTransitionEnd(element, callback);
  }

  function cancelPanelTransition(panel) {
    if (panel._affiliatePanelTransitionCancel) {
      panel._affiliatePanelTransitionCancel();
      panel._affiliatePanelTransitionCancel = null;
    }
  }

  function getPanelContentHeight(panel) {
    var inner = panel.querySelector('[data-affiliate-accordion-panel-inner]');
    return Math.ceil(inner ? inner.getBoundingClientRect().height : panel.scrollHeight);
  }

  function getPanelTransition() {
    return 'height ' + DURATION + 'ms ' + EASING + ', margin ' + DURATION + 'ms ' + EASING + ', opacity 220ms ' + EASING;
  }

  function preparePanel(panel) {
    cancelPanelTransition(panel);

    var styles = window.getComputedStyle(panel);
    var currentHeight = Math.round(panel.getBoundingClientRect().height);

    panel.style.transition = 'none';
    panel.style.height = currentHeight + 'px';
    panel.style.marginTop = styles.marginTop;
    panel.style.marginBottom = styles.marginBottom;
    panel.style.opacity = styles.opacity;
    panel.style.overflow = 'hidden';
    panel.style.willChange = 'height, margin, opacity';
    panel.classList.add('is-animating');
    panel.offsetHeight;
  }

  function openPanel(trigger, panel) {
    preparePanel(panel);

    trigger.classList.add('active');
    trigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-open');
    panel.style.transition = getPanelTransition();

    window.requestAnimationFrame(function () {
      panel.style.height = getPanelContentHeight(panel) + 'px';
      panel.style.marginTop = PANEL_MARGIN + 'px';
      panel.style.marginBottom = PANEL_MARGIN + 'px';
      panel.style.opacity = '1';
    });

    panel._affiliatePanelTransitionCancel = onHeightTransitionEnd(panel, function () {
      panel._affiliatePanelTransitionCancel = null;
      panel.classList.remove('is-animating');
      panel.style.height = 'auto';
      panel.style.marginTop = '';
      panel.style.marginBottom = '';
      panel.style.opacity = '';
      panel.style.overflow = '';
      panel.style.transition = '';
      panel.style.willChange = '';
    });
  }

  function closePanel(trigger, panel) {
    preparePanel(panel);

    trigger.classList.remove('active');
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.classList.remove('is-open');
    panel.style.transition = getPanelTransition();

    window.requestAnimationFrame(function () {
      panel.style.height = '0px';
      panel.style.marginTop = '0px';
      panel.style.marginBottom = '0px';
      panel.style.opacity = '0';
    });

    panel._affiliatePanelTransitionCancel = onHeightTransitionEnd(panel, function () {
      panel._affiliatePanelTransitionCancel = null;
      panel.classList.remove('is-animating');
      panel.style.height = '';
      panel.style.marginTop = '';
      panel.style.marginBottom = '';
      panel.style.opacity = '';
      panel.style.overflow = '';
      panel.style.transition = '';
      panel.style.willChange = '';
    });
  }

  function finishOuterToggle(outer, list) {
    outer.classList.remove('is-toggling');
    outer.dataset.affiliateAccordionToggling = 'false';
    list.style.height = '';
    list.style.overflow = '';
    list.style.transition = '';
    list.style.willChange = '';
  }

  function toggleOuter(outer, moreButton) {
    var list = outer.querySelector('.accordion-box');
    var willOpen = outer.classList.contains('hidden-some');

    if (!list) {
      moreButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      outer.classList.toggle('hidden-some', !willOpen);
      return;
    }

    if (outer.dataset.affiliateAccordionToggling === 'true') return;
    outer.dataset.affiliateAccordionToggling = 'true';
    moreButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

    var startHeight = Math.round(list.getBoundingClientRect().height);
    var endHeight = willOpen ? list.scrollHeight : COLLAPSED_HEIGHT;

    list.style.transition = 'none';
    list.style.height = startHeight + 'px';
    list.style.overflow = 'hidden';
    list.style.willChange = 'height';
    outer.classList.add('is-toggling');

    if (willOpen) {
      outer.classList.remove('hidden-some');
    } else {
      outer.classList.add('hidden-some');
    }

    list.offsetHeight;
    list.style.transition = 'height ' + DURATION + 'ms ' + EASING;

    window.requestAnimationFrame(function () {
      list.style.height = endHeight + 'px';
    });

    afterTransition(list, function () {
      finishOuterToggle(outer, list);
    });
  }

  function initAccordion(root) {
    if (!root || root.dataset.affiliateAccordionInitialized === 'true') return;
    root.dataset.affiliateAccordionInitialized = 'true';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-affiliate-accordion-trigger]'));
    var outer = root.querySelector('[data-affiliate-accordion-outer]');
    var moreButton = root.querySelector('[data-affiliate-accordion-more]');

    triggers.forEach(function (trigger) {
      var panel = trigger.parentElement.querySelector('[data-affiliate-accordion-panel]');
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.classList.contains('active');

        triggers.forEach(function (otherTrigger) {
          var otherPanel = otherTrigger.parentElement.querySelector('[data-affiliate-accordion-panel]');
          if (otherPanel && otherTrigger.classList.contains('active')) {
            closePanel(otherTrigger, otherPanel);
          }
        });

        if (!isOpen) {
          openPanel(trigger, panel);
        }
      });
    });

    if (outer && moreButton) {
      moreButton.addEventListener('click', function () {
        toggleOuter(outer, moreButton);
      });
    }
  }

  function initAll(scope) {
    var roots = Array.prototype.slice.call((scope || document).querySelectorAll('[data-affiliate-accordion]'));
    roots.forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
